import {ReactElement} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

interface RenameIconProps {
    onClick: () => void;
    tooltip: string | ReactElement;
}

const RenameIcon = ({onClick, tooltip}: RenameIconProps): JSX.Element => (
    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>} placement={'top'}>
        <i
            className="fs-1 fa-solid fa-edit cursor-pointer"
            style={{margin: '6%'}}
            onClick={onClick}
        ></i>
    </OverlayTrigger>
);

export default RenameIcon;
